/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * sim_table.csvの中身を整形したデータ
 * @export
 * @interface SimTableResponse
 */
export interface SimTableResponse {
    /**
     * ①ダムありの流量
     * @type {number}
     * @memberof SimTableResponse
     */
    maxFlowDam?: number;
    /**
     * ②ダムなしの流量
     * @type {number}
     * @memberof SimTableResponse
     */
    maxFlowNodam?: number;
    /**
     * ①ダムありの水位
     * @type {number}
     * @memberof SimTableResponse
     */
    maxWlevelDam?: number;
    /**
     * ②ダムなしの水位
     * @type {number}
     * @memberof SimTableResponse
     */
    maxWlevelNodam?: number;
    /**
     * ③ダム調節効果の流量
     * @type {number}
     * @memberof SimTableResponse
     */
    floodControlEffectFlow?: number;
    /**
     * ③ダム調節効果の水位
     * @type {number}
     * @memberof SimTableResponse
     */
    floodControlEffectWlevel?: number;
}

/**
 * Check if a given object implements the SimTableResponse interface.
 */
export function instanceOfSimTableResponse(value: object): value is SimTableResponse {
    return true;
}

export function SimTableResponseFromJSON(json: any): SimTableResponse {
    return SimTableResponseFromJSONTyped(json, false);
}

export function SimTableResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimTableResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'maxFlowDam': json['max_flow_dam'] == null ? undefined : json['max_flow_dam'],
        'maxFlowNodam': json['max_flow_nodam'] == null ? undefined : json['max_flow_nodam'],
        'maxWlevelDam': json['max_wlevel_dam'] == null ? undefined : json['max_wlevel_dam'],
        'maxWlevelNodam': json['max_wlevel_nodam'] == null ? undefined : json['max_wlevel_nodam'],
        'floodControlEffectFlow': json['flood_control_effect_flow'] == null ? undefined : json['flood_control_effect_flow'],
        'floodControlEffectWlevel': json['flood_control_effect_wlevel'] == null ? undefined : json['flood_control_effect_wlevel'],
    };
}

export function SimTableResponseToJSON(json: any): SimTableResponse {
    return SimTableResponseToJSONTyped(json, false);
}

export function SimTableResponseToJSONTyped(value?: SimTableResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'max_flow_dam': value['maxFlowDam'],
        'max_flow_nodam': value['maxFlowNodam'],
        'max_wlevel_dam': value['maxWlevelDam'],
        'max_wlevel_nodam': value['maxWlevelNodam'],
        'flood_control_effect_flow': value['floodControlEffectFlow'],
        'flood_control_effect_wlevel': value['floodControlEffectWlevel'],
    };
}

